import { useContext } from "react";
import { CostCenterDashboardContext } from "./PurchaseCostCenter.provider";

export function useCostCenterDashboardContext() {
  const context = useContext(CostCenterDashboardContext); // Use o contexto diretamente

  if (!context) {
    throw new Error(
      "usePieceDashboardContext deve ser utilizado apenas dentro de CostCenterDashboardProvider"
    );
  }

  return context;
}